<template>
  <div>

    <div v-if="!infoCollected">

      <v-container grid-list-lg fill-height fluid class="pa-0">
        <v-stepper v-if="!infoCollected" vertical v-model="step" class="elevation-0">


          <v-stepper-step :complete="step > 1" step="1">
            Sponsor
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-list dense class="py-0" v-for="(group, index) in group" :key="index">
              <v-subheader>{{ group.name }}</v-subheader>
              <v-list-item two-line v-for="(item, i) in group.items" :key="i">
                <v-list-item-action>
                  <v-btn depressed color="primary" @click="plus(item)" x-small fab>
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                  <v-list-item-subtitle class="caption">{{ item.qty }}x {{ item.amount | currency
                  }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn depressed color="error" :disabled="item.qty === 0 ? true : false" @click="minus(item)" x-small
                    fab>
                    <v-icon>mdi mdi-minus</v-icon>
                  </v-btn>
                </v-list-item-action>

              </v-list-item>
            </v-list>

            <div class="text-center caption mt-2 red--text">
              <span class="font-weight-bold">{{ sponsorTotal / 12 | currency }}</span> each month for 12 months
            </div>



            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="sponsorTotal === 0 ? true : false" @click="sponsorDone" color="primary">Next</v-btn>
            </v-card-actions>
          </v-stepper-content>


          <v-stepper-step :complete="step > 2" step="2">
            Payment Preferences
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-col cols="12" class="py-2">
              <div class="mb-2">Payment Cycle?</div>
              <v-btn-toggle dense v-model="donationObj.paymentCycle" color="primary">
                <v-btn outlined small value="monthly">
                  Monthly
                </v-btn>

                <v-btn outlined small value="oneTime">
                  One Time
                </v-btn>

              </v-btn-toggle>
            </v-col>
            <v-col cols="12">
              <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="dateFormatted" outlined dense label="Starting Date" readonly hide-details
                    v-bind="attrs" @blur="startingDate = parseDate(dateFormatted)" v-on="on"></v-text-field>
                </template>
                <v-date-picker :min="minDate" v-model="startingDate" no-title @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col v-if="donationObj.paymentCycle === 'monthly'" cols="12" class="text-caption text-md-body-1 text-lg-h6">
              We will collect a payment of <span class="font-weight-bold">{{ sponsorTotal / 12 | currency }}</span> on the
              <span class="font-weight-bold">{{ getFormattedDay(startingDate) }}</span> day of each month for
              a 12-month
              cycle. Starting from <span class="font-weight-bold">{{ startingDate | moment('LL') }}</span>. At
              the end of
              the 12-month cycle, your sponsorship will come to a close.
            </v-col>
            <v-col v-else cols="12" class="text-caption text-md-body-1 text-lg-h6">
              We will collect a payment of <span class="font-weight-bold">{{ sponsorTotal | currency }}</span> on the
              <span class="font-weight-bold">{{ startingDate | moment('LL') }}</span>. for whole year of
              sponsorship.
            </v-col>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn text @click="step = step - 1">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="preferencesDone" color="primary">next</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <v-stepper-step :complete="step > 3" step="3">
            Payment Method
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-row>
              <v-col cols="12" class="py-2">
                <div class="mb-2">How you like to pay?</div>
                <v-btn-toggle small dense v-model="donationObj.paymentType" color="primary">
                  <v-btn outlined small value="card">
                    Credit/Debit Card
                  </v-btn>

                  <v-btn outlined small value="ach">
                    Bank Account
                  </v-btn>

                </v-btn-toggle>
              </v-col>
            </v-row>

            <!-- v-if="donationObj.paymentType === 'ach'" -->
            <v-row class="mt-2" v-show="donationObj.paymentType === 'ach'">
              <v-col cols="12">
                <div class="mb-2">Account Type?</div>
                <v-btn-toggle small dense v-model="donationObj.accountType" color="primary">
                  <v-btn outlined small value="personal">
                    Personal
                  </v-btn>

                  <v-btn outlined small value="business">
                    Business
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field autofocus outlined dense :error-messages="nameErrors"
                  :background-color="`${sponsor.name ? false : '#E8F5E9'}`" :hide-details="nameErrors.length === 0"
                  v-model="sponsor.name" label="Your Name">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field outlined dense type="tel" v-mask="'(###) ###-####'"
                  :background-color="`${sponsor.phoneNumber ? false : '#E8F5E9'}`" :error-messages="phoneNumberErrors"
                  :hide-details="phoneNumberErrors.length === 0" v-model="sponsor.phoneNumber"
                  label="Phone Number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field outlined dense :background-color="`${sponsor.email ? false : '#E8F5E9'}`"
                  :error-messages="emailErrors" :hide-details="emailErrors.length === 0" v-model="sponsor.email"
                  label="Email Address"></v-text-field>
              </v-col>

              <v-col cols="12" sm="12">
                <v-text-field outlined dense :error-messages="accountNameErrors"
                  :hide-details="accountNameErrors.length === 0"
                  :background-color="`${paymentMethod.accountName ? false : '#E8F5E9'}`"
                  v-model="paymentMethod.accountName" label="Name On Account"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field outlined dense :error-messages="bankNameErrors" :hide-details="bankNameErrors.length === 0"
                  :background-color="`${paymentMethod.bankName ? false : '#E8F5E9'}`" v-model="paymentMethod.bankName"
                  label="Bank Name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field outlined dense :error-messages="routingNumberErrors"
                  :hide-details="routingNumberErrors.length === 0" type="tel"
                  :background-color="`${paymentMethod.routingNumber ? false : '#E8F5E9'}`"
                  v-model.trim="paymentMethod.routingNumber" label="Routing Number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field outlined dense :error-messages="accountNumberErrors"
                  :hide-details="accountNumberErrors.length === 0" type="tel"
                  :background-color="`${paymentMethod.accountNumber ? false : '#E8F5E9'}`"
                  v-model.trim="paymentMethod.accountNumber" label="Account Number"></v-text-field>
              </v-col>
            </v-row>

            <v-row class="mt-2" v-show="donationObj.paymentType === 'card'">
              <v-col cols="12" sm="12" md="6">
                <v-text-field autofocus outlined dense :error-messages="nameErrors"
                  :background-color="`${sponsor.name ? false : '#E8F5E9'}`" :hide-details="nameErrors.length === 0"
                  v-model.trim="sponsor.name" label="Your Name">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field outlined dense v-mask="'(###) ###-####'" type="tel"
                  :background-color="`${sponsor.phoneNumber ? false : '#E8F5E9'}`" :error-messages="phoneNumberErrors"
                  :hide-details="phoneNumberErrors.length === 0" v-model="sponsor.phoneNumber"
                  label="Phone Number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field outlined dense :background-color="`${sponsor.email ? false : '#E8F5E9'}`"
                  :error-messages="emailErrors" :hide-details="emailErrors.length === 0" v-model="sponsor.email"
                  label="Email Address"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field outlined dense type="tel" :background-color="`${card.cardNumber ? false : '#E8F5E9'}`"
                  :error-messages="cardNumberErrors" :hide-details="cardNumberErrors.length === 0"
                  v-model.trim="card.cardNumber" label="Card Number"></v-text-field>
              </v-col>
              <v-col sm="6" md="6">
                <v-text-field outlined dense type="tel" v-mask="'##/##'"
                  :background-color="`${card.expiryDate ? false : '#E8F5E9'}`" :error-messages="expiryDateErrors"
                  :hide-details="expiryDateErrors.length === 0" v-model.trim="card.expiryDate"
                  label="Expiry Date"></v-text-field>
              </v-col>
              <v-col sm="6" md="6">
                <v-text-field outlined dense type="tel" :background-color="`${card.cvvCode ? false : '#E8F5E9'}`"
                  :error-messages="cvvCodeErrors" :hide-details="cvvCodeErrors.length === 0" v-model.trim="card.cvvCode"
                  label="CVV Code"></v-text-field>
              </v-col>
            </v-row>



            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-btn text @click="step = step - 1">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="cardDone" :loading="cardLoading" color="primary">next</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <v-stepper-step :complete="step > 4" step="4">
            Complete
          </v-stepper-step>

          <v-stepper-content step="4">
            <v-card-text>
              <v-col v-if="donationObj.paymentCycle === 'monthly'" cols="12"
                class="text-caption text-md-body-1 text-lg-h6">
                We will collect a payment of <span class="font-weight-bold">{{ sponsorTotal / 12 | currency }}</span> on
                the
                <span class="font-weight-bold">{{ getFormattedDay(startingDate) }}</span> day of each month for
                a 12-month
                cycle. Starting from <span class="font-weight-bold">{{ startingDate | moment('LL') }}</span>. At
                the end of
                the 12-month cycle, your sponsorship will come to a close.
              </v-col>
              <v-col v-else cols="12" class="text-caption text-md-body-1 text-lg-h6">
                We will collect a payment of <span class="font-weight-bold">{{ sponsorTotal | currency }}</span> on the
                <span class="font-weight-bold">{{ startingDate | moment('LL') }}</span>. for whole year of
                sponsorship.
              </v-col>
              <!-- <p class="caption">By pressing submit button i am allowing Muhammadi Masjid to collect 300 Monthly till
                4/2/2023 </p> -->

              <v-btn block :loading="loadingSubmit" color="primary" @click="submit">
                Submit
              </v-btn>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn large block text @click="step = step - 1">Back</v-btn>
              <!-- <v-spacer></v-spacer> -->
              <!-- <v-btn @click="studentDone" v-if="takeCard" color="primary" large>next</v-btn> -->
              <!-- <v-btn @click="submitWithOutCard" :loading="loading" color="primary" large>Submit</v-btn> -->
            </v-card-actions>
          </v-stepper-content>

        </v-stepper>
      </v-container>
    </div>

    <div v-else>
      <v-card-text>
        <lottie :height="200" :options="defaultOptions" name="receiptCheck" v-on:animCreated="handleAnimation" />
        <div class="text-center">
          <div class="text-h5">All Set</div>
          <div class="mt-3">We will contact you soon insh Allah.</div>
        </div>
      </v-card-text>
    </div>

    <v-footer class="padless" app>
      <v-col class="text-center pa-0" cols="12">
        {{ version }} — <span>Power by: </span><strong>taleem.app</strong>
      </v-col>
    </v-footer>
  </div>
</template>


<script>
import applicationService from "@/modules/Application/service.js";
const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");
import Lottie from "@/components/lottie.vue";
// import GlobalFunction from "@/mixins/GlobalFunction";
import * as animationData from "@/assets/lottie/1708-success.json";
const pjson = require("../../../../package.json");
// import Stripe from 'stripe';
const encryptor = require("simple-encryptor")(process.env.VUE_APP_KEY);


export default {
  name: "sponsor-page",
  props: ['currentBusiness', 'takeCard'],
  data() {
    return {
      cardLoading: false,
      loadingSubmit: false,
      token: null,
      // stripePublicKey: process.env.VUE_APP_STRIPE_PK,
      dateFormatted: null,
      minDate: null,
      menu1: false,
      step: 1,
      infoCollected: false,
      openTermBox: false,
      loading: false,
      Business: null,
      complete: false,

      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
      },
      startingDate: null,
      group: [
        {
          name: 'Hifz School',
          items: [
            {
              text: 'Boys Hifz Sponsor',
              amount: '1200',
              qty: 0,
              stripeProductId: 'prod_LZsCZmsDtedy5z',
              ProductId: 1,
            },
            {
              text: 'Girls Hifz Sponsor',
              amount: '1200',
              qty: 0,
              stripeProductId: 'prod_LZsCZmsDtedy5z',
              ProductId: 1,
            },
          ],
        },
        {
          name: 'Maktab School',
          items: [
            {
              text: 'Boys Maktab Sponsor',
              amount: '600',
              qty: 0,
              stripeProductId: 'prod_LaZiku6ufPhTcW',
              ProductId: 2,
            },
            {
              text: 'Girls Maktab Sponsor',
              amount: '600',
              qty: 0,
              stripeProductId: 'prod_LaZiku6ufPhTcW',
              ProductId: 2,
            },
          ],
        }
      ],
      model: 1,
      sponsor: {
        phoneNumber: null,
        name: null,
        email: null,
      },
      card: {
        cardNumber: null,
        expiryDate: null,
        cvvCode: null,
      },
      paymentMethod: {
        accountName: null,
        bankName: null,
        routingNumber: null,
        accountNumber: null,
      },
      Donation: {},
      donationObj: {
        paymentType: 'card',
        paymentCycle: 'monthly',
        accountType: 'personal',
        startingDate: null,
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    sponsor: {
      phoneNumber: {
        required,
      },
      name: {
        required,
      },
      email: {
        required,
        email,
      },
    },
    card: {
      cardNumber: {
        required,
      },
      expiryDate: {
        required,
      },
      cvvCode: {
        required,
      },
    },
    paymentMethod: {
      accountName: {
        required,
      },
      bankName: {
        required,
      },
      routingNumber: {
        required,
      },
      accountNumber: {
        required,
      },
    },
  },
  computed: {
    sponsorTotal() {
      let total = 0
      this.group.map(row => {
        row.items.map(item => {
          if (item.qty != 0) {
            total += item.qty * item.amount
          }
        })
      })
      return total
    },
    version() {
      return pjson.version;
    },
    cardNumberErrors() {
      const errors = [];
      if (!this.$v.card.cardNumber.$dirty) return errors;
      if (!this.$v.card.cardNumber.required)
        errors.push("Card Number is required");
      return errors;
    },
    expiryDateErrors() {
      const errors = [];
      if (!this.$v.card.expiryDate.$dirty) return errors;
      if (!this.$v.card.expiryDate.required)
        errors.push("Expiry Date is required");
      return errors;
    },
    cvvCodeErrors() {
      const errors = [];
      if (!this.$v.card.cvvCode.$dirty) return errors;
      if (!this.$v.card.cvvCode.required)
        errors.push("CVV Code is required");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.sponsor.name.$dirty) return errors;
      if (!this.$v.sponsor.name.required) errors.push("Name is required");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.sponsor.phoneNumber.$dirty) return errors;
      if (!this.$v.sponsor.phoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.sponsor.email.$dirty) return errors;
      if (!this.$v.sponsor.email.required)
        errors.push("Email Address is required");
      if (!this.$v.sponsor.email.email)
        errors.push("Please enter a valid email address");
      return errors;
    },
    accountNameErrors() {
      const errors = [];
      if (!this.$v.paymentMethod.accountName.$dirty) return errors;
      if (!this.$v.paymentMethod.accountName.required)
        errors.push("Account name is required");
      return errors;
    },
    bankNameErrors() {
      const errors = [];
      if (!this.$v.paymentMethod.bankName.$dirty) return errors;
      if (!this.$v.paymentMethod.bankName.required)
        errors.push("Bank name is required");
      return errors;
    },
    routingNumberErrors() {
      const errors = [];
      if (!this.$v.paymentMethod.routingNumber.$dirty) return errors;
      if (!this.$v.paymentMethod.routingNumber.required) errors.push("Routing number is required");
      return errors;
    },
    accountNumberErrors() {
      const errors = [];
      if (!this.$v.paymentMethod.accountNumber.$dirty) return errors;
      if (!this.$v.paymentMethod.accountNumber.required)
        errors.push("Account number is required");
      return errors;
    },
  },
  components: {
    Lottie,
  },
  created() {
    // let a = "(718) 299-2222";

    // let st = a.replace(/[^a-zA-Z0-9]/g, "");

    // console.log("test test", st);
    this.loadBusiness();
    this.startingDate = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
    this.dateFormatted = this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))
    this.minDate = this.$moment(this.Donation.startingDate).format('YYYY-MM-DD');
    this.Business = this.currentBusiness

  },
  watch: {
    startingDate() {
      this.dateFormatted = this.formatDate(this.startingDate)
    },
    currentBusiness(val) {
      this.StripeKey = val.metadata.publicStripeId;
      this.Classes = val.Classes;
    }
  },
  methods: {
    // createToken(card) {
    //   // this.cardLoading = true
    //   console.log('card', card)
    //   applicationService.publicCreateStripeToken(card).then((response) => {
    //     console.log('token', response)
    //     this.token = response.id;

    //     this.cardLoading = false
    //     return response.id
    //   }).catch(error => {
    //     console.log('error', error)
    //     throw error
    //   })
    // },
    async cardDone() {

      if (this.donationObj.paymentType === 'card') {
        this.$v.card.$touch();
        this.$v.sponsor.$touch();

        if (this.$v.card.$invalid || this.$v.sponsor.$invalid) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: this.$t("toastMessage.text.invalidFields"),
            });
        } else {
          this.cardLoading = true
          const expiryDate = this.card.expiryDate.split("/");
          let card = {
            name: this.sponsor.name,
            number: this.card.cardNumber,
            exp_month: expiryDate[0],
            exp_year: `20${expiryDate[1]}`,
            cvc: this.card.cvvCode,
            BusinessId: this.Business.id
          }

          applicationService.publicCreateStripeToken(card).then((response) => {
            console.log('token', response)
            this.token = response.data.id;

            this.cardLoading = false
            // return response.id
            this.step = 4
          }).catch((error) => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
            this.cardLoading = false
            console.log('error token', error)
          })
        }

      } else {
        this.$v.paymentMethod.$touch();
        this.$v.sponsor.$touch();

        if (this.$v.paymentMethod.$invalid || this.$v.sponsor.$invalid) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: this.$t("toastMessage.text.invalidFields"),
            });
        } else {
          this.step = 4
        }
      }



    },
    getFormattedDay(date) {
      const dayOfMonth = this.$moment(date).date();
      const suffix = this.getDaySuffix(dayOfMonth);
      return dayOfMonth + suffix;
    },
    getDaySuffix(day) {
      if (day >= 11 && day <= 13) {
        return "th";
      }
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    plus(item) {
      item.qty += 1
    },
    minus(item) {
      item.qty -= 1
    },
    preferencesDone() {
      this.step = 3
    },
    sponsorDone() {
      this.step = 2
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    loadBusiness() {
      let id = this.$route.params.id;
      console.log("id", id);
      applicationService
        .getBusinessInformation({ key: '7327393945' })
        .then((response) => {
          console.log("response", response);
          this.Business = response.data;
          this.StripeKey = this.Business.metadata.publicStripeId;
          // this.Classes = this.Business.Classes;
        })
        .catch((error) => {
          console.log("error", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    deleteItem(item) {
      this.Students.splice(this.Students.indexOf(item), 1);
      // this.editedIndex = this.Students.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialogDelete = true
    },
    // submitWithOutCard() {
    //   console.log('submitWithOutCard')
    //   if (this.Students.length === 0) {
    //     this.$swal
    //       .mixin({
    //         toast: true,
    //         position: "top-end",
    //         showConfirmButton: false,
    //         timer: 3000,
    //       })
    //       .fire({
    //         icon: "error",
    //         title: "Please add student",
    //       });
    //   } else {
    //     this.submit()
    //   }
    // },
    async submit() {
      // const data = await createToken();
      // this.$v.Lead.$touch();
      // if (this.$v.Lead.$invalid) {
      //   this.$swal
      //     .mixin({
      //       toast: true,
      //       position: "top-end",
      //       showConfirmButton: false,
      //       timer: 3000,
      //     })
      //     .fire({
      //       icon: "error",
      //       title: this.$t("toastMessage.text.invalidFields"),
      //     });
      // } else {
      // if (this.Students.length === 0) {
      //   this.$swal
      //     .mixin({
      //       toast: true,
      //       position: "top-end",
      //       showConfirmButton: false,
      //       timer: 4000,
      //     })
      //     .fire({
      //       icon: "error",
      //       title: "Please Enter Student",
      //     });
      //   this.loading = false;
      //   this.dialog = true;
      // }
      try {
        this.loadingSubmit = true;
        const selectedItems = [];
        for (const group of Object.values(this.group)) {
          for (const item of group.items) {
            if (item.qty > 0) {
              selectedItems.push({
                ...item,
                name: item.text,
                price: item.amount,
                ProductId: item.ProductId,
              });
            }
          }
        }
        //  this.Lead.students = this.Students;
        if (this.sponsor.phoneNumber) {
          this.sponsor.phoneNumber = this.sponsor.phoneNumber.replace(
            /[^a-zA-Z0-9]/g,
            ""
          );
        }
        let PaymentMethodEncrypted = null
        if (this.donationObj && this.donationObj.paymentType === 'ach') {
          PaymentMethodEncrypted = {
            processingType: this.donationObj.paymentType,
            accountType: this.donationObj.accountType,
          };

          if (this.paymentMethod.accountName)
            PaymentMethodEncrypted.name = encryptor.encrypt(
              this.paymentMethod.accountName
            );
          if (this.paymentMethod.bankName)
            PaymentMethodEncrypted.bankName = encryptor.encrypt(
              this.paymentMethod.bankName
            );
          if (this.paymentMethod.routingNumber)
            PaymentMethodEncrypted.routingNumber = encryptor.encrypt(
              this.paymentMethod.routingNumber
            );
          if (this.paymentMethod.accountNumber)
            PaymentMethodEncrypted.accountNumber = encryptor.encrypt(
              this.paymentMethod.accountNumber
            );
          if (this.card.cardNumber)
            PaymentMethodEncrypted.cardNumber = encryptor.encrypt(
              this.card.cardNumber
            );
          if (this.card.expiryDate)
            PaymentMethodEncrypted.expirationDate = encryptor.encrypt(
              this.card.expiryDate
            );
          if (this.card.cvvCode)
            PaymentMethodEncrypted.cvvCode = encryptor.encrypt(
              this.card.cvvCode
            );
          // if (this.paymentMethod.cardType)
          PaymentMethodEncrypted.cardType = encryptor.encrypt(
            'local'
          );
          if (this.paymentMethod.zipCode)
            PaymentMethodEncrypted.zipCode = encryptor.encrypt(
              this.paymentMethod.zipCode
            );
        }

        this.Donation = {
          sponsor: this.sponsor,
          token: this.token,
          // paymentMethod: PaymentMethodEncrypted,
          donationObj: this.donationObj,
          business: this.Business,
          selectedItems: selectedItems
        }
        this.Donation.donationObj.startingDate = this.startingDate

        if (this.donationObj && this.donationObj.paymentType === 'ach') {
          this.Donation.paymentMethod = PaymentMethodEncrypted
        }

        //   console.log('lead', this.Lead)
        // this.Lead.students = this.Students;
        // this.Lead.status = "Open"
        // this.Lead = {
        //   ...this.Lead,
        //   ...this.Emergency,
        //   ...this.Address,
        // }



        // if (this.takeCard) {
        //   let data = {};
        //   // data = await createToken();
        //   // console.log('token data', data)
        //   if (data.error) {
        //     console.log("error adding card", data);
        //     this.$swal
        //       .mixin({
        //         toast: true,
        //         position: "top-end",
        //         showConfirmButton: false,
        //         timer: 3000,
        //       })
        //       .fire({
        //         icon: "error",
        //         title: data.error.message,
        //       });
        //     this.loading = false;
        //     return false
        //   }
        //   // this.Lead.token = data.token
        // }



        // if (this.Lead.fatherPhoneNumber) {
        //   this.Lead.fatherPhoneNumber = this.Lead.fatherPhoneNumber.replace(
        //     /[^a-zA-Z0-9]/g,
        //     ""
        //   );
        // }

        // if (this.Lead.motherPhoneNumber) {
        //   this.Lead.motherPhoneNumber = this.Lead.motherPhoneNumber.replace(
        //     /[^a-zA-Z0-9]/g,
        //     ""
        //   );
        // }

        // if (this.Lead.emergencyPhoneNumber) {
        //   this.Lead.emergencyPhoneNumber =
        //     this.Lead.emergencyPhoneNumber.replace(/[^a-zA-Z0-9]/g, "");
        // }

        console.log("this.Students.length", this.currentBusiness, this.Donation);
        this.loadingSubmit = true;
        applicationService
          .publicSponsorCreate(this.Business.code, this.Donation)
          .then(() => {
            // console.log("response", response);
            this.infoCollected = true;
            this.loadingSubmit = false;
          })
          .catch((err) => {
            this.loadingSubmit = false;
            console.log("err", err);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.message,
              });
          });
        // this.loading = false;
      } catch (error) {
        this.loadingSubmit = false;
        console.log("error adding card", error);
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: error.message,
          });
      }
    }
  },
  // },
};
</script>

<style scoped>
.centerdiv {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  margin: auto;
}
</style>